import { QuizQuestion } from "../../../common/components/quiz/useQuiz";

export const dashboardQuizQuestions: QuizQuestion[] = [
  {
    id: "dashboard-q1",
    prompt: "What does the Date Filter on the Dashboard do?",
    options: [
      { id: "a", label: "Exports dashboard data to Excel" },
      { id: "b", label: "Changes the time range for the charts" },
      { id: "c", label: "Filters clients by registration date" },
      { id: "d", label: "Sorts the Top 10 Regions table" },
    ],
    correctOptionId: "b",
    explanation:
      "The Date Filter updates the time range for both the Product Usage Rate and Total Subscriptions charts. You can choose from presets like Today, Last Month, or set a Custom range.",
  },
  {
    id: "dashboard-q2",
    prompt: "What does a longer bar in the Total Product Usage Rate chart mean?",
    options: [
      { id: "a", label: "The product has more facilities assigned to it" },
      { id: "b", label: "The product has more transactions" },
      { id: "c", label: "The product is newer" },
      { id: "d", label: "The product has fewer clients" },
    ],
    correctOptionId: "b",
    explanation:
      "Bar length is proportional to the total number of transactions for that product. More transactions = longer bar.",
  },
  {
    id: "dashboard-q3",
    prompt: "In the Total Subscriptions chart, what does the dark blue bar represent?",
    options: [
      { id: "a", label: "Clients subscribed to the product" },
      { id: "b", label: "Facilities subscribed to the product" },
      { id: "c", label: "Total transactions for the product" },
      { id: "d", label: "Products with the most growth" },
    ],
    correctOptionId: "b",
    explanation:
      "The dark blue bar (top) represents Facilities, while the light blue bar (bottom) represents Clients. Both are shown per product.",
  },
  {
    id: "dashboard-q4",
    prompt: "What does the Product Filter in the Geographic Distribution Dashboard do?",
    options: [
      { id: "a", label: "Filters the Top 10 Regions table by region name" },
      { id: "b", label: "Updates the map markers to show only facilities for a specific product" },
      { id: "c", label: "Removes all data from the chart" },
      { id: "d", label: "Sorts facilities alphabetically" },
    ],
    correctOptionId: "b",
    explanation:
      "Selecting a product from the Product Filter updates the map to show only facilities assigned to that product. Choosing All Products shows all facilities.",
  },
  {
    id: "dashboard-q5",
    prompt: "How do you view a detailed breakdown of product distribution for a region?",
    options: [
      { id: "a", label: "Click the region name" },
      { id: "b", label: "Use the Date Filter" },
      { id: "c", label: "Hover over the region row in the Top 10 Regions table" },
      { id: "d", label: "Click a bubble on the map" },
    ],
    correctOptionId: "c",
    explanation:
      "Hovering over a row in the Top 10 Regions table shows a detailed tooltip with Facilities count, Top Product, and a full product distribution breakdown for that region.",
  },
];
